import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";

import * as moment from "moment";

@Injectable()
export class GuardianNotificationRegService {
	constructor(private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianNotificationInfoGet
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianNotificationInfoGet(PersonID: number) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GuardianNotificationInfoGet";

		var promise$ = this.httpclientService.post(url, PersonID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianGetList
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianGetList(PersonID, SchoolID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GuardianGetList?PersonID=" + PersonID + "&SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SendEmail
	//
	//-----------------------------------------------------------------------------------------------------
	SendEmail(RegistrationNbr, RegistrationExpireDT, StudentPersonID, UserPersonID, parents) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/SendEmail";
		var param = {
			RegistrationNbr,
			RegistrationExpireDT,
			StudentPersonID,
			UserPersonID,
			parents,
		};
		var promise$ = this.httpclientService.post(url, param);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GetRegistration
	//
	//-----------------------------------------------------------------------------------------------------
	GetRegistration(StudentID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GetAppRegistrationNbr?StudentID=" + StudentID;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	CreateRegistration (Reset Date Only if it exists)
	//
	//-----------------------------------------------------------------------------------------------------
	CreateRegistration(StudentID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/CreateAppRegistrationNbr?StudentID=" + StudentID;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	CreateRegistration (Reset Number and Date if it exists)
	//
	//-----------------------------------------------------------------------------------------------------
	CreateRegistrationReset(StudentID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/CreateAppRegistrationResetNbr?StudentID=" + StudentID;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	register
	//
	//-----------------------------------------------------------------------------------------------------
	register(Body, SendToList) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/SendEmail?Body=" + Body + "&SendToList=" + SendToList;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotifyLanguageSelectList() {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/NotifyLanguageSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotifyLanguageModify(PersonID, NotifyLanguageID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/NotifyLanguageModify?PersonID=" + PersonID + "&NotifyLanguageID=" + NotifyLanguageID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
